import { useRef } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import axios from '../../utils/axios';
import LoadingBar from 'react-top-loading-bar';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const navigate = useNavigate();
    const loading = useRef(null);

    const initialValues = {
        title: '',
        slug: '',
        content: '',
        tags: [],
        hasProduct: '',
        categoriesId: []
    };

    const validationSchema = Yup.object({
        title: Yup.string().required().max(128),
        slug: Yup.string().required(),
        content: Yup.string().required(),
        tags: Yup.array().required()
    });

    const onSubmit = values => {
        document.getElementsByClassName('btn-success')[0].classList.add('btn-loading');
        loading.current.continuousStart();
        const postedData = {
            ...values,
            has_product: values.hasProduct,
            tags: values.tags.join(','),
            categories_id: values.categoriesId.join(',')
        };
        axios.post('pages/create',postedData).then(({data}) => {
            if(data.status){
                toast.success(data.message);
                navigate('/pages');
            }else
                data.error.map(error => toast.error(error))
        }).finally(() => {
            loading.current.complete();
            document.getElementsByClassName('btn-success')[0].classList.remove('btn-loading')
        });
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema
    });

    return (
        <>
            <LoadingBar color="#4088c7" ref={loading} height={3} shadow={0} />
            <div className="page-header">
                <h1 className="page-title">ایجاد صفحه جدید</h1>
            </div>
            <div className="row">
                <Form formik={formik} />
            </div>
        </>
    )
}

export default Create;